import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

// import { Input } from "@/components/ui/input";

type BreadcrumberProps = {
  children?: React.ReactNode;
};

const Breadcrumber = ({ children }: BreadcrumberProps) => {
  return (
    <div className="flex flex-row justify-between gap-4 px-4 py-4 w-full">
      <div className="flex-1">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem className="text-sm text-gray-600 dark:text-gray-300">
              <BreadcrumbLink href="/dashboard">Dashboard</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <div className="flex flex-wrap items-center">
              <>{children}</>
            </div>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
      {/* <div>
        <Input placeholder="Search..." />
      </div> */}
    </div>
  );
};

export default Breadcrumber;
